import createTableStore from "ds/components/Table/store/useTableStore";

import { STACK_TASKS_TABLE_COLUMNS_CONFIG, STACK_TASKS_TABLE_STORAGE_KEY } from "./constants";

const useStackTasksTableStore = createTableStore({
  storageKey: STACK_TASKS_TABLE_STORAGE_KEY,
  config: STACK_TASKS_TABLE_COLUMNS_CONFIG,
});

export default useStackTasksTableStore;
